import http from "./http-common";

class PrivatePolicyComplianceConfigService {
  update(params: any) {
    return http.post("private-policy-compliance-config/update", params);
  }
}

export default new PrivatePolicyComplianceConfigService();
